import React, { useEffect, useState } from 'react';
import { Flexbox, ButtonLight, TextField, formatMessage, FormFieldContainer, Image, IconPath, Hooks } from 'cw-ui-core';
import Locale from 'src/i18n';
import css from './NewFilterConditions.scss';
import cx from 'classnames';
import Flyout from 'src/components/Flyout/Flyout';
import DismissContextHOC from 'src/components/DismissContextHoc';
import { Manager, Popper, Reference } from 'react-popper';
import TextButton from 'src/components/TextButton';
import { Features, hasFeature } from 'src/util/featureToggles';
import UserGridFiltersContainer from 'src/features/users/components/UserGridFilters/UserGridFiltersContainer';
import RenderIfHasPermissions from 'src/components/RenderIfHasPermissions/RenderIfHasPermissions';
import { PERMISSIONS } from 'src/constants';
import { checkIfUserHaveGivenPermissions } from 'src/util/Util';

const FilterConditions = props => {
    const {
        onAddUser,
        onAuthMethodSelect,
        onUpdateMfaMethodSelect,
        onResetPassword,
        disabledOnNoneSelect,
        disabledUnlessActiveSelect,
        disabledOnExternalAuthSelect,
        disabledUnlessPendingSelect,
        disabledUnlessDisabledSelect,
        disableWhenActiveSelected,
        disabledWhenDisableSelected,
        disableDownloadUsers,
        onResendInvite,
        onDownloadUsersCsv,
        isUserAuditInProgress,
        onNewDeleteAccount,
        onEnableAccount,
        onDisableAccount,
        searchText,
        filterList,
        onNewManageRolesSelect,
        onInfoIconClick,
        isLoading,
        onBulkImportUser,
    } = props;

    const [isUserSettingFlyout, setIsUserSettingFlyout] = useState(false);
    const [isAddUsersFlyout, setIsAddUsersFlyout] = useState(false);
    const hasBulkUserImportFeature = hasFeature(Features.BULK_USER_ASSIGNMENT);

    const [isFilterFlyout, setIsFilterFlyout] = useState(false);

    const [searchValue, setSearchValue] = Hooks.useDebounceOnChangeHandler(filterList, 500, searchText);

    useEffect(() => {
        setSearchValue(searchText);
    }, [searchText]);

    const shouldShowMoreBulkOperationsButton = checkIfUserHaveGivenPermissions(
        [PERMISSIONS.USERS_ENABLE, PERMISSIONS.USERS_DELETE],
        true
    );

    const bulkUserImportHandler = () => {
        onBulkImportUser();
        setIsAddUsersFlyout(false);
    };

    const onAddUserImportHandler = () => {
        onAddUser();
        setIsAddUsersFlyout(false);
    };

    const userSettingContent = () => {
        return (
            <>
                <RenderIfHasPermissions requiredPermissions={[PERMISSIONS.USERS_ENABLE]}>
                    <TextButton
                        key="enable_user"
                        automationName="enable_user"
                        className={css.listMoreItem}
                        text={formatMessage(Locale.enableUser)}
                        onClick={() => {
                            onEnableAccount();
                            setIsUserSettingFlyout(false);
                        }}
                        disabled={disabledUnlessDisabledSelect || disabledOnNoneSelect}
                    />
                    <TextButton
                        key="disable_user"
                        automationName="disable_user"
                        className={css.listMoreItem}
                        text={formatMessage(Locale.disableUser)}
                        onClick={() => {
                            onDisableAccount();
                            setIsUserSettingFlyout(false);
                        }}
                        disabled={disabledWhenDisableSelected || disabledOnNoneSelect}
                    />
                </RenderIfHasPermissions>
                <RenderIfHasPermissions requiredPermissions={[PERMISSIONS.USERS_DELETE]}>
                    <TextButton
                        key="delete_user"
                        automationName="delete_user"
                        className={css.listMoreItem}
                        text={formatMessage(Locale.deleteAccount)}
                        onClick={() => {
                            onNewDeleteAccount();
                            setIsUserSettingFlyout(false);
                        }}
                        disabled={disabledOnNoneSelect}
                    />
                </RenderIfHasPermissions>
            </>
        );
    };

    const addUserOptions = () => {
        return (
            <Flexbox column className={css.mfaflyoutContainer}>
                <TextButton
                    key="Add_User"
                    automationName="Add_User"
                    className={css.listMoreItemAddUser}
                    text={formatMessage(Locale.addUserOption)}
                    onClick={onAddUserImportHandler}
                />
                <TextButton
                    key="Bulk_User_Import"
                    automationName="Bulk_User_Import"
                    className={css.listMoreItemAddUser}
                    text={formatMessage(Locale.BulkUserImportBtn)}
                    onClick={bulkUserImportHandler}
                />
            </Flexbox>
        );
    };

    const filterContent = () => {
        return <UserGridFiltersContainer setIsFilterFlyout={setIsFilterFlyout} />;
    };
    const userSettingFlyout = <Flyout className={css.userSettingContainer} Content={userSettingContent} />;
    const addUsersFlyout = <Flyout className={css.addUserDropdownContainer} Content={addUserOptions} />;
    const userSettingFlyoutDismissContext = DismissContextHOC(userSettingFlyout, () => {
        setIsUserSettingFlyout(!isUserSettingFlyout);
    });
    const addUserFlyoutDismissContext = DismissContextHOC(addUsersFlyout, () => {
        setIsAddUsersFlyout(!addUsersFlyout);
    });

    const filterFlyout = <Flyout className={css.userFiltersContainer} Content={filterContent} />;

    const filterFlyoutDismissContext = DismissContextHOC(filterFlyout, () => {
        setIsFilterFlyout(!isFilterFlyout);
    });

    let downloadUsersListClass = css.downloadCsvIcon;

    if (disableDownloadUsers) {
        downloadUsersListClass = css.downloadCsvIconDisabled;
    } else if (isUserAuditInProgress) {
        downloadUsersListClass = cx(css.downloadCsvIcon, css.downloadCsvIconSelected);
    }

    const disableResetPassword = disabledOnNoneSelect || disabledUnlessActiveSelect || disabledOnExternalAuthSelect;
    const disableResendInvite = disabledOnNoneSelect || disabledUnlessPendingSelect || disableWhenActiveSelected;
    const disableUpdateMfa = disabledOnNoneSelect || disabledOnExternalAuthSelect;

    const shouldShowAddUserDropdown = () => {
        return hasBulkUserImportFeature ? (
            <Manager>
                <Reference>
                    {({ ref }) => (
                        <div ref={ref}>
                            <Flexbox
                                className={
                                    isAddUsersFlyout
                                        ? cx(css.userSettingsButton, css.userSettingsButtonSelected)
                                        : css.userSettingsButton
                                }
                                automationName="user_Setting_flyout"
                                onClick={e => {
                                    e.stopPropagation();
                                    setIsAddUsersFlyout(!isAddUsersFlyout);
                                }}>
                                <ButtonLight
                                    value={formatMessage(Locale.addUser)}
                                    automationName="add_user"
                                    className={css.addUser}
                                />
                            </Flexbox>
                        </div>
                    )}
                </Reference>
                {isAddUsersFlyout && (
                    <Popper placement="bottom">
                        {({ ref, style, placement }) => (
                            <div
                                cw-id="addUserFlyout"
                                ref={ref}
                                data-placement={placement}
                                style={style}
                                className={css.addUserSettingFlyout}>
                                {addUserFlyoutDismissContext}
                            </div>
                        )}
                    </Popper>
                )}
            </Manager>
        ) : (
            <ButtonLight
                value={formatMessage(Locale.addUser)}
                automationName="add_user"
                onClick={onAddUser}
                className={css.addUser}
            />
        );
    };

    return (
        <Flexbox className={css.toolBar}>
            <Flexbox className={css.titleLeftWrap}>
                <RenderIfHasPermissions requiredPermissions={[PERMISSIONS.USERS_CREATE]}>
                    {shouldShowAddUserDropdown()}
                </RenderIfHasPermissions>
                <RenderIfHasPermissions requiredPermissions={[PERMISSIONS.USERS_ROLES_UPDATE]}>
                    <Image
                        key="updateUserRole"
                        automationName="updateUserRole"
                        alt={formatMessage(Locale.updateRole)}
                        src={IconPath.get('Application_DispatchPortal')}
                        className={cx(css.bulkOperationIcon, {
                            [css.disabledBulkOperationIcon]: disabledOnNoneSelect,
                            [css.enabledBulkOperationIcon]: !disabledOnNoneSelect,
                        })}
                        title={formatMessage(Locale.updateRole)}
                        onClick={() => {
                            if (!disabledOnNoneSelect) {
                                onNewManageRolesSelect();
                            }
                        }}
                    />
                </RenderIfHasPermissions>
                <RenderIfHasPermissions requiredPermissions={[PERMISSIONS.USERS_AUTH_UPDATE]}>
                    <Image
                        key="setAuthMethod"
                        automationName="setAuthMethod"
                        alt={formatMessage(Locale.setAuthMethod)}
                        src={IconPath.get('Menu_Access')}
                        className={cx(css.bulkOperationIcon, {
                            [css.disabledBulkOperationIcon]: disabledOnNoneSelect,
                            [css.enabledBulkOperationIcon]: !disabledOnNoneSelect,
                        })}
                        title={formatMessage(Locale.setAuthMethod)}
                        onClick={() => {
                            if (!disabledOnNoneSelect) {
                                onAuthMethodSelect();
                            }
                        }}
                    />
                    <Image
                        key="updateMfa"
                        automationName="updateMfa"
                        alt={formatMessage(Locale.updateMandatoryMfa)}
                        src={IconPath.get('Status_Grayware')}
                        className={cx(css.bulkOperationIcon, {
                            [css.disabledBulkOperationIcon]: disableUpdateMfa,
                            [css.enabledBulkOperationIcon]: !disableUpdateMfa,
                        })}
                        title={formatMessage(Locale.updateMandatoryMfa)}
                        onClick={() => {
                            if (!disabledOnNoneSelect && !disabledOnExternalAuthSelect) {
                                onUpdateMfaMethodSelect();
                            }
                        }}
                    />
                </RenderIfHasPermissions>
                <RenderIfHasPermissions requiredPermissions={[PERMISSIONS.USERS_PASSWORD_RESET]}>
                    <Image
                        key="resetPassword"
                        automationName="resetPassword"
                        alt={formatMessage(Locale.resetPassword)}
                        src={IconPath.get('Status_Unlocked')}
                        className={cx(css.bulkOperationIcon, {
                            [css.disabledBulkOperationIcon]: disableResetPassword,
                            [css.enabledBulkOperationIcon]: !disableResetPassword,
                        })}
                        title={formatMessage(Locale.resetPassword)}
                        onClick={() => {
                            if (!disableResetPassword) {
                                onResetPassword();
                            }
                        }}
                    />
                </RenderIfHasPermissions>
                <RenderIfHasPermissions requiredPermissions={[PERMISSIONS.USERS_EMAIL_RESEND]}>
                    <Image
                        key="resendInvite"
                        automationName="resendInvite"
                        alt={formatMessage(Locale.resendInvite)}
                        src={IconPath.get('ManagementPack_Messaging')}
                        className={cx(css.bulkOperationIcon, {
                            [css.disabledBulkOperationIcon]: disableResendInvite,
                            [css.enabledBulkOperationIcon]: !disableResendInvite,
                        })}
                        title={formatMessage(Locale.resendInvite)}
                        onClick={() => {
                            if (!disableResendInvite) {
                                onResendInvite();
                            }
                        }}
                    />
                </RenderIfHasPermissions>
                {shouldShowMoreBulkOperationsButton && (
                    <Flexbox className={css.userSettingContainer}>
                        <Manager>
                            <Reference>
                                {({ ref }) => (
                                    <div ref={ref}>
                                        <Flexbox
                                            className={
                                                isUserSettingFlyout
                                                    ? cx(css.userSettingsButton, css.userSettingsButtonSelected)
                                                    : css.userSettingsButton
                                            }
                                            automationName="user_Setting_flyout"
                                            onClick={e => {
                                                e.stopPropagation();
                                                setIsUserSettingFlyout(!isUserSettingFlyout);
                                            }}>
                                            <Image
                                                key="moreBulkOperations"
                                                automationName="moreBulkOperations"
                                                src={IconPath.get('Application_More')}
                                                className={css.bulkOperationIcon}
                                            />
                                        </Flexbox>
                                    </div>
                                )}
                            </Reference>
                            {isUserSettingFlyout && (
                                <Popper placement="bottom">
                                    {({ ref, style, placement }) => (
                                        <div
                                            cw-id="userSettingFlyout"
                                            ref={ref}
                                            data-placement={placement}
                                            style={style}
                                            className={css.userSettingFlyout}>
                                            {userSettingFlyoutDismissContext}
                                        </div>
                                    )}
                                </Popper>
                            )}
                        </Manager>
                    </Flexbox>
                )}
                <RenderIfHasPermissions requiredPermissions={[PERMISSIONS.USERS_EXPORT]}>
                    <Image
                        key="downloadUsersList"
                        automationName="downloadUsersList"
                        alt={formatMessage(Locale.downloadUsersList)}
                        src={IconPath.get('Action_Download')}
                        onClick={() => {
                            if (!disableDownloadUsers) onDownloadUsersCsv();
                        }}
                        className={downloadUsersListClass}
                        title={formatMessage(Locale.downloadUsersList)}
                    />
                </RenderIfHasPermissions>
            </Flexbox>
            <Flexbox className={css.titleLeftWrap}>
                <Flexbox className={css.userFiltersContainer}>
                    <Manager>
                        <Reference>
                            {({ ref }) => (
                                <div ref={ref}>
                                    <Flexbox
                                        className={
                                            isFilterFlyout
                                                ? cx(css.userSettingsButton, css.userSettingsButtonSelected)
                                                : cx({
                                                      [css.disabledFilterUsersIcon]: isLoading,
                                                      [css.userSettingsButton]: !isLoading,
                                                  })
                                        }
                                        automationName="user_Filter_flyout"
                                        onClick={e => {
                                            e.stopPropagation();
                                            if (!isLoading) setIsFilterFlyout(!isFilterFlyout);
                                        }}>
                                        <Image
                                            key="filterUsers"
                                            automationName="filterUsers"
                                            src={IconPath.get('Action_Filter')}
                                            className={css.filterUsersIcon}
                                        />
                                    </Flexbox>
                                </div>
                            )}
                        </Reference>
                        {isFilterFlyout && (
                            <Popper placement="bottom">
                                {({ ref, style, placement }) => (
                                    <div
                                        cw-id="filterFlyout"
                                        ref={ref}
                                        data-placement={placement}
                                        style={style}
                                        className={css.filterFlyout}>
                                        {filterFlyoutDismissContext}
                                    </div>
                                )}
                            </Popper>
                        )}
                    </Manager>
                </Flexbox>
                <FormFieldContainer path={['usersSearchText']} screenKey="activeScreen">
                    <TextField
                        cwId="userSearch"
                        automationName="userSearch"
                        className={cx(css.searchField, css.searchIcon)}
                        placeholder={formatMessage(Locale.searchPlaceholder)}
                        value={searchValue}
                        onChange={setSearchValue}
                    />
                </FormFieldContainer>
                <Image
                    key="infoUniversityLink"
                    automationName="infoUniversityLink"
                    src={IconPath.get('Application_Help')}
                    onClick={onInfoIconClick}
                />
            </Flexbox>
        </Flexbox>
    );
};

export default FilterConditions;
